var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackgroundAsset = function SvgBackgroundAsset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 350,
    height: 282,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#background-asset_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-asset_svg__b)",
    d: "M26.426 18.19 90.23-45.613a172.4 172.4 0 0 0-31.363 23.002l-9.44 9.44C40.643-3.617 32.898 6.863 26.426 18.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-asset_svg__c)",
    d: "M7.39 68.896 140.935-64.647c-3.699.732-7.321 1.618-10.942 2.581L9.972 57.954a155 155 0 0 0-2.581 10.942"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-asset_svg__d)",
    d: "M4 102.84v1.079L175.919-68h-1.079c-2.466 0-4.97.077-7.398.154L4.154 95.442C4.077 97.908 4 100.374 4 102.84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-asset_svg__e)",
    d: "M6.66 132.97 204.972-65.342a155 155 0 0 0-7.205-1.117L5.543 125.765c.308 2.389.693 4.816 1.117 7.205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-asset_svg__f)",
    d: "M13.133 158.13 230.13-58.868a121 121 0 0 0-6.319-2.004L11.129 151.81c.616 2.119 1.31 4.238 2.004 6.319"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-asset_svg__g)",
    d: "M22.572 180.361 252.4-49.468c-1.849-.963-3.737-1.849-5.625-2.735L19.835 174.736a127 127 0 0 0 2.737 5.625"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-asset_svg__h)",
    d: "M34.438 200.166 272.204-37.6a142 142 0 0 0-5.009-3.352L31.085 195.157a94 94 0 0 0 3.353 5.009"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-asset_svg__i)",
    d: "M48.462 217.812 289.81-23.538c-1.464-1.31-2.928-2.62-4.431-3.89L44.57 213.38a139 139 0 0 0 3.892 4.431"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-asset_svg__j)",
    d: "M64.567 233.339 305.338-7.431a214 214 0 0 0-3.891-4.47L60.097 229.448a202 202 0 0 0 4.47 3.891"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-asset_svg__k)",
    d: "M82.794 246.825 318.826 10.793a142 142 0 0 0-3.352-5.009L77.785 243.473c1.657 1.117 3.314 2.235 5.009 3.352"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-asset_svg__l)",
    d: "M103.254 257.998 330 31.252c-.886-1.888-1.772-3.776-2.736-5.625L97.59 255.302c1.888.924 3.776 1.849 5.664 2.696"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-asset_svg__m)",
    d: "M126.252 266.667 338.704 54.215c-.616-2.119-1.31-4.238-2.003-6.318L119.934 264.664c2.042.732 4.161 1.387 6.318 2.003"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-asset_svg__n)",
    d: "M152.337 272.216 344.214 80.339a149 149 0 0 0-1.117-7.243L145.094 271.099c2.427.462 4.816.809 7.243 1.117"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-asset_svg__o)",
    d: "M174.839 273.719c2.658 0 5.278-.077 7.86-.193l162.787-162.787c.116-2.62.193-5.24.193-7.86v-.655L174.184 273.719z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-asset_svg__p)",
    d: "m220.344 267.592 119.249-119.249a175 175 0 0 0 2.659-10.981L209.363 270.251c3.699-.771 7.359-1.695 10.981-2.659"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#background-asset_svg__q)",
    d: "m322.679 188.568-62.148 62.149c25.738-14.988 47.199-36.449 62.148-62.149"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-asset_svg__b",
    x1: 58.328,
    x2: 58.328,
    y1: -45.614,
    y2: 18.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFE49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#F8D067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-asset_svg__c",
    x1: 74.162,
    x2: 74.162,
    y1: -64.647,
    y2: 68.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFE49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#F8D067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-asset_svg__d",
    x1: 89.959,
    x2: 89.959,
    y1: -68,
    y2: 103.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFE49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#F8D067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-asset_svg__e",
    x1: 105.257,
    x2: 105.257,
    y1: -66.459,
    y2: 132.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFE49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#F8D067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-asset_svg__f",
    x1: 120.63,
    x2: 120.63,
    y1: -60.872,
    y2: 158.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFE49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#F8D067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-asset_svg__g",
    x1: 136.118,
    x2: 136.118,
    y1: -52.203,
    y2: 180.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFE49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#F8D067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-asset_svg__h",
    x1: 151.645,
    x2: 151.645,
    y1: -40.952,
    y2: 200.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFE49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#F8D067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-asset_svg__i",
    x1: 167.191,
    x2: 167.191,
    y1: -27.429,
    y2: 217.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFE49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#F8D067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-asset_svg__j",
    x1: 182.718,
    x2: 182.718,
    y1: -11.901,
    y2: 233.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFE49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#F8D067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-asset_svg__k",
    x1: 198.306,
    x2: 198.306,
    y1: 5.784,
    y2: 246.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFE49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#F8D067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-asset_svg__l",
    x1: 213.795,
    x2: 213.795,
    y1: 25.627,
    y2: 257.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFE49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#F8D067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-asset_svg__m",
    x1: 229.319,
    x2: 229.319,
    y1: 47.897,
    y2: 266.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFE49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#F8D067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-asset_svg__n",
    x1: 244.654,
    x2: 244.654,
    y1: 73.096,
    y2: 272.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFE49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#F8D067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-asset_svg__o",
    x1: 259.931,
    x2: 259.931,
    y1: 102.224,
    y2: 273.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFE49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#F8D067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-asset_svg__p",
    x1: 275.807,
    x2: 275.807,
    y1: 137.362,
    y2: 270.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFE49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#F8D067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "background-asset_svg__q",
    x1: 291.605,
    x2: 291.605,
    y1: 188.568,
    y2: 250.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FFE49E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#F8D067"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "background-asset_svg__a",
    width: 349.68,
    height: 349.719,
    x: 0,
    y: -68,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1066_49922"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1066_49922",
    result: "shape"
  })))));
};
export default SvgBackgroundAsset;